import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import { KeyVaultHeaderToolbarProps } from '../Model/KeyVaultProps';
import SearchBar from '../../../../Common/Components/Controls/SearchBar';
import CustomButton from '../../../../Common/Components/Controls/InputControls';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';

export default function KeyVaultHeaderToolbar(
  props: Readonly<KeyVaultHeaderToolbarProps>,
) {
  const { onFilterRequest } = props;
  const permissions = useContext(PermissionsContext);

  const hasKeyVaultWritePermission = () => !!permissions['SecureKeyWriter'];

  return (
    <HeaderToolbar
      leftContent={<SearchBar onChange={onFilterRequest} width="35%" />}
      rightContent={
        hasKeyVaultWritePermission() && (
          <CustomButton
            component={Link}
            to={'/keyvault/create'}
            startIcon={<AddIcon />}
            label="Add"
          />
        )
      }
    />
  );
}
